import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Twitter, Instagram, Linkedin } from 'lucide-react';
import { motion } from 'framer-motion';
import logo from "../assets/logo.png";

const Footer = () => {
  const fadeInUp = {
    initial: { opacity: 0, y: 20 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true },
    transition: { duration: 0.6 }
  };

  return (
    <footer className="bg-gradient-to-br from-[#1e3a5f] to-[#2d5a7b] text-white">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About Section */}
          <motion.div {...fadeInUp}>
            <img
              src={logo}
              alt="Venugram Hospital"
              className="h-16 w-auto mb-4"
            />
            <p className="text-gray-300 text-sm leading-relaxed mb-4">
              ISO Certified 25+ Bed Multispeciality Hospital & Research Institute.
            </p>
            <div className="flex space-x-4">
              <motion.a
                whileHover={{ scale: 1.1, y: -3 }}
                href="#"
                className="p-2 bg-white/10 rounded-full hover:bg-[#6FCF97] transition-colors duration-300"
              >
                <Facebook size={18} />
              </motion.a>
              <motion.a
                whileHover={{ scale: 1.1, y: -3 }}
                href="#"
                className="p-2 bg-white/10 rounded-full hover:bg-[#6FCF97] transition-colors duration-300"
              >
                <Twitter size={18} />
              </motion.a>
              <motion.a
                whileHover={{ scale: 1.1, y: -3 }}
                href="#"
                className="p-2 bg-white/10 rounded-full hover:bg-[#6FCF97] transition-colors duration-300"
              >
                <Instagram size={18} />
              </motion.a>
              <motion.a
                whileHover={{ scale: 1.1, y: -3 }}
                href="#"
                className="p-2 bg-white/10 rounded-full hover:bg-[#6FCF97] transition-colors duration-300"
              >
                <Linkedin size={18} />
              </motion.a>
            </div>
          </motion.div>

          {/* Quick Links */}
          <motion.div {...fadeInUp} transition={{ delay: 0.1 }}>
            <h3 className="text-lg font-semibold mb-4 text-[#6FCF97]">Quick Links</h3>
            <ul className="grid grid-cols-2 gap-y-2 gap-x-6">
              {['Home', 'About Us', 'Specialities', 'Consultants', 'Facilities' , 'Gallery', 'Contact'].map((link) => (
                <li key={link}>
                  <Link
                    to={`/${link.toLowerCase().replace(' ', '-')}`}
                    className="text-gray-300 hover:text-[#6FCF97] transition-colors duration-200 text-sm"
                  >
                    {link}
                  </Link>
                </li>
              ))}
            </ul>
          </motion.div>

          {/* Services */}
          <motion.div {...fadeInUp} transition={{ delay: 0.2 }}>
            <h3 className="text-lg font-semibold mb-4 text-[#6FCF97]">Services</h3>
            <ul className="space-y-2 text-sm text-gray-300">
              <li>24/7 Emergency Care</li>
              <li>ICU & Critical Care</li>
              <li>Dialysis</li>
              <li>Laboratory Services</li>
            </ul>
          </motion.div>

          {/* Contact Info */}
          <motion.div {...fadeInUp} transition={{ delay: 0.3 }}>
            <h3 className="text-lg font-semibold mb-4 text-[#6FCF97]">Contact Us</h3>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <MapPin size={18} className="text-[#6FCF97] mt-1 flex-shrink-0" />
                <p className="text-sm text-gray-300">
                  Deshpande Nagar, Hubballi, Karnataka 580029
                </p>
              </div>
              <div className="flex items-center space-x-3">
                <Phone size={18} className="text-[#6FCF97] flex-shrink-0" />
                <div className="text-sm text-gray-300">
                  <p>0836-2228390, +91 7996524417</p>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <Mail size={18} className="text-[#6FCF97] flex-shrink-0" />
                <p className="text-sm text-gray-300">suvaidyamhospital@gmail.com</p>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Bottom Bar */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.5 }}
          className="mt-12 pt-8 border-t border-white/10"
        >
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-400">
              © 2026 Suvaidyam Hospital. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm text-gray-400">
              <Link to="https://x7ittechnologies.com" className="hover:text-[#6FCF97] transition-colors duration-200">
                Developed By X7 IT Technologies
              </Link>
            </div>
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;